import useBundleGlobal from 'hooks/useBundleGlobal'
import { decode } from 'helpers/utils'
import useDetectBreakpoint from 'hooks/useDetectBreakpoint'
import CarouselSwiper from 'modules/carousel-swiper/carousel-swiper'
import ProductCard from 'snippets/product-card/product-card'
import LoaderSpin from 'snippets/loader-spin/loader-spin'
import ProductCardCustom from 'snippets/product-card/products-card-custom'

export default function ProductCarousel({
  products,
  options,
  selector,
  heading = '',
  isLoading = false,
  navigation = true,
  pagination = false,
  scrollbar = false,
  textButton,
  paginationTypeNumber = false,
  className = 'relative flex flex-col',
  classHeading = '',
  classWrapper = '',
  classNavigation = '',
  classBadges,
  classItemSlide,
  classButton,
  classProductWrap,
  classProductInfo = '',
  isCustomProductCard = false,
  classWishlistButton
}) {
  let productData = products
  let carouselOptions = options
  const { productBundles } = useBundleGlobal()
  const { isDesktop } = useDetectBreakpoint()
  const atcButtonText = textButton || 'Add'

  if (products && typeof products === 'string') {
    productData = JSON.parse(decode(products))
  }

  if (options && typeof options === 'string') {
    carouselOptions = JSON.parse(options)
  }

  const optionsDefault = {
    slidesPerView: 2,
    spaceBetween: 1,
    observeSlideChildren: true,
    freeMode: {
      enabled: true,
      sticky: true
    },
    pagination: {
      clickable: false
    },
    grabCursor: true,
    speed: 500,
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      }
    }
  }

  const currentOptions = carouselOptions || optionsDefault

  return (
    <div className={className}>
      {isLoading ? (
        <div className="flex h-96 w-full items-center justify-center">
          <LoaderSpin size="8" />
        </div>
      ) : (
        <>
          {heading && !isLoading && (
            <h2 className={`max-w-[calc(100%-90px)] font-extrabold px-5 pb-4 text-xs pt-5 md:px-10 md:pt-7 md:pb-6 md:text-sm ${classHeading}`}>
              {heading}
            </h2>
          )}
          {productData.length > 0 && (
            <CarouselSwiper
              options={currentOptions}
              navigation={navigation}
              pagination={pagination}
              scrollbar={scrollbar}
              selector={selector}
              classWrapper={`border-neutral-900 ${isCustomProductCard ? 'border-t' : 'border-y carousel-slide-dividers'} ${classWrapper}`}
              paginationTypeNumber={paginationTypeNumber}
              classNavigation={classNavigation}
            >
              <ProductItems
                products={productData}
                productBundles={productBundles}
                classBadges={classBadges}
                classItemSlide={classItemSlide}
                classProductWrap={classProductWrap}
                isDesktop={isDesktop}
                classProductInfo={classProductInfo}
                classButton={classButton}
                textButton={atcButtonText}
                isCustomProductCard={isCustomProductCard}
                classWishlistButton={classWishlistButton}
              />
            </CarouselSwiper>
          )}
        </>
      )}
    </div>
  )
}

function ProductItems({
  products,
  textButton = 'Add to bag',
  classItemSlide,
  classButton,
  classBadges,
  isDesktop,
  productBundles = [],
  classProductWrap,
  classProductInfo = '',
  isCustomProductCard = false,
  classWishlistButton
}) {
  return products.map((product) => (
    <swiper-slide key={product.variants[0].id} className={classItemSlide}>
      {isCustomProductCard ? (
        <ProductCardCustom
          product={product}
          productBundles={productBundles}
        />
      ) : (
        <ProductCard
          product={product}
          classProductWrap={classProductWrap}
          classButton={classButton}
          textButton={textButton}
          isDesktop={isDesktop}
          productBundles={productBundles}
          classBadges={classBadges}
          classProductInfo={classProductInfo}
          useCustomButtonAtc
          classWishlistButton={classWishlistButton}
        />
      )}
    </swiper-slide>
  ))
}
